// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul{font-size:.7rem;font-weight:300;margin-bottom:0}@media(min-width:768px){ul{font-size:.9rem}}@media(min-width:992px){ul{font-size:1rem}}@media print{ul{font-size:12pt}}", ""]);
// Exports
module.exports = exports;
